module.exports = __webpack_public_path__ + "assets/icon-handle-set.7fa55912.svg";